export default __webpack_public_path__ + "static/media/icon-content.f1e00aef.svg";